import React from 'react';
import { logError } from '@services/log-service';
import ServerErrorPage from '@components/server-error-page';

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error details
    logError(error, {
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return <ServerErrorPage error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
